import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { BookMeetingButtonWithAccountManagerGuard } from "app/pages/sales-intelligence/common-components/BookMeetingButton/BookMeetingButtonWithAccountManagerGuard";
import { useAccountManagerChiliPiperSlug } from "app/pages/sales-intelligence/sub-modules/account-manager/queries/useAccountManagersQuery";

import { ModalBody, SuccessImageWrapper, SuccessSubtitle, SuccessTitle } from "./styles";
import SuccessImage from "./SuccessImage";

type ModalContentProps = {
    title: string;
    subTitle: string;
    buttonText?: string;
    onClick: () => void;
};

/**
 * Shared "Thanks for reaching out" body used by every Sales Intelligence
 * Contact-Us modal (premium features, quotas, locked overlays, etc.).
 *
 * When the current account has a Salesforce Account Manager (or Account
 * Success Manager) whose ChiliPiper personal-link slug was successfully
 * resolved by `/sales-api/account-managers`, a primary "Book a meeting" CTA
 * is shown next to the close button. Otherwise the modal falls back to the
 * legacy single-button layout. The hook share is deduped via React Query, so
 * mounting this component anywhere is safe.
 */
const ModalContent = ({ title, subTitle, buttonText, onClick }: ModalContentProps) => {
    const slug = useAccountManagerChiliPiperSlug();

    return (
        <ModalBody>
            <div>
                <SuccessImageWrapper>
                    <SuccessImage />
                </SuccessImageWrapper>
                <SuccessTitle>{title}</SuccessTitle>
                <SuccessSubtitle>{subTitle}</SuccessSubtitle>
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    gap="16px"
                    style={{ marginTop: 56 }}
                >
                    <Button
                        type={slug ? "outlined" : "primary"}
                        onClick={onClick}
                        data-automation="contact-us-thanks-close"
                    >
                        {buttonText ?? translate("si.modal.get_feature.success.btn.got-it")}
                    </Button>
                    <BookMeetingButtonWithAccountManagerGuard
                        label="contact-us-thanks"
                        buttonType="primary"
                        onClick={onClick}
                    >
                        {translate("si.common.book_a_meeting")}
                    </BookMeetingButtonWithAccountManagerGuard>
                </Flex>
            </div>
        </ModalBody>
    );
};

export default ModalContent;
